import React, { useState, useRef, useEffect } from 'react';
import { Switch, Empty, Table, Button, Col, Tag, Drawer, Form, Input, Row, Select, Space, message, Modal, Typography, InputNumber } from 'antd';
import { CloseOutlined, CheckOutlined } from '@ant-design/icons';
import { insert, update, getById } from '../../../../apis/MovimientoCompanyApi';
import { getList } from '../../../../apis/ConceptoApi';
import { getList as getAllAnalitica } from '../../../../apis/OdooAnaliticaApi';
import _ from 'lodash';

const { Option } = Select;
const App = ({ title, id, open, finish }) => {
    const [form] = Form.useForm()
    const [ID, setID] = useState(id);
    const [modified, setModified] = useState(false);
    const [initialValues, setInitialValues] = useState(null);
    const searchInput = useRef(null);
    const [conceptos, setConceptos] = useState([]);
    const [concepto, setConcepto] = useState(null);
    const [analiticas, setAnaliticas] = useState([]);
    const [analitica, setAnalitica] = useState(null);

    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            if (!values) return;
        } catch (errorInfo) {
            console.log('Failed:', errorInfo);
            return;
        }

        let success = false;
        const fields = form.getFieldsValue()
        if (ID > 0) {
            //Update
            const payload = {
                id: ID,
                ...fields
            }
            const response = await update(payload);
            success = response.ok;
            if (response.ok) {
                message.success('Se actualizó correctamente el movimiento!');
            }
        } else {
            //Create
            const payload = {
                id: ID,
                ...fields
            }
            const response = await insert(payload);
            success = response.ok;
            if (response.ok) {
                setID(response.payload);
                message.success('Se guardo correctamente el movimiento!');
            }
        }

        if (success) {
            setModified(true);
            onClose(true);
        }
    }

    const onClose = (reload) => {
        finish(reload ?? modified);
        setInitialValues(null);
    }

    const effectRan = useRef(false);
    useEffect(() => {
        if (!effectRan.current) {
            (async () => {
                await getCatalogs();

                if (ID > 0) {
                    await refreshData();
                } else {
                    setInitialValues({
                        concepto: null,
                        monto: null,
                        exento: null,
                        dias: null,
                        horas: null,
                        analitica: null,
                        referencia: null,
                        activo: true
                    });
                }
                setModified(false)
            })();
        }
        return () => effectRan.current = true;
    }, []);

    React.useEffect(() => {
        if (conceptos.length > 0 && initialValues && initialValues.concepto) {
            const conceptoSeleccionado = conceptos.find(c => c.value === initialValues.concepto);
            if (conceptoSeleccionado) {
                setConcepto(conceptoSeleccionado);
            }
        }

        if (analiticas.length > 0 && initialValues && initialValues.analitica) {
            const analiticaId = typeof initialValues.analitica === 'object' ?
                initialValues.analitica.id : initialValues.analitica;

            const analiticaSeleccionada = analiticas.find(a => a.id === analiticaId);
            if (analiticaSeleccionada) {
                setAnalitica(analiticaSeleccionada);
            }
        }

        // Si initialValues cambia, actualizar el formulario
        if (initialValues) {
            form.setFieldsValue(initialValues);
        }
    }, [conceptos, analiticas, initialValues]);

    const changeAnalitica = async (value) => {
        var _analitica = analiticas.find(x => x.value == value);

        setAnalitica(_analitica);
    }

    const refreshData = async () => {
        const response = await getById(ID);
        if (response.ok) {
            let item = response.payload;
            setInitialValues(item);
        }
    }

    const getCatalogs = async () => {
        const response = await getList();
        if (response.ok) {
            debugger;
            let items = response.payload;
            setConceptos(items);
        }
        const responseAnaliticas = await getAllAnalitica();
        if (responseAnaliticas.ok) {
            let analiticasItems = responseAnaliticas.payload.map(item => ({
                value: item.id,
                text: item.name,
                id: item.id,
                originalData: item
            }));
            setAnaliticas(analiticasItems);
            console.log('Analíticas cargadas:', analiticasItems);
        }
    }

    return (
        <Drawer
            title={title}
            width={720}
            placement={"right"}
            onClose={onClose}
            open={open}
            closable={true}
            extra={<Space>
                <Button onClick={onClose}>Cancelar</Button>
                <Button onClick={handleOk} type="primary">
                    Guardar
                </Button>
            </Space>}
        >
            <>
                <div>
                    <div style={{ float: 'left' }}>
                        <span title=""></span>
                    </div>
                    <span class="" style={{ float: 'right' }}>

                    </span>
                </div>
                {/* <PageHeader ghost={false} title="Remisiones" extra={[ 
                <Space>
                    <Button onClick={onClose}>Cancelar</Button>
                    <Button onClick={handleOk} type="primary">
                    Guardar
                    </Button>
                </Space>]} />*/}
                {
                    initialValues &&
                    <Form
                        layout="vertical"
                        form={form}
                        requiredMark
                        autoComplete="off"
                        initialValues={initialValues}
                        onFinish={handleOk}>
                        <Row gutter={16}>
                            <Col md={{ span: 12 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                                <Form.Item
                                    name="concepto_id"
                                    label="Concepto"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Selecciona un concepto',
                                        },
                                    ]}
                                >
                                    <Select placeholder="Por favor selecciona un concepto">
                                        {
                                            conceptos.map((item) => <Option value={item.value}>{item.displayTitle}</Option>)
                                        }
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col md={{ span: 12 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                                <Form.Item
                                    name="monto"
                                    label="Monto"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Por favor agrega un monto',
                                        },
                                    ]}>
                                    <InputNumber placeholder="Por favor agrega un monto" style={{ width: '80%', }} />
                                </Form.Item>
                            </Col>
                            <Col md={{ span: 12 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                                <Form.Item
                                    name="exento"
                                    label="Exento"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Por favor agrega un monto',
                                        },
                                    ]}>
                                    <InputNumber placeholder="Por favor agrega un monto" style={{ width: '80%', }} />
                                </Form.Item>
                            </Col>
                            <Col md={{ span: 12 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                                <Form.Item
                                    name="dias"
                                    label="Días"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Por favor agrega los dias',
                                        },
                                    ]}>
                                    <InputNumber placeholder="Por favor agrega los dias" style={{ width: '80%', }} />
                                </Form.Item>
                            </Col>
                            <Col md={{ span: 12 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                                <Form.Item
                                    name="horas"
                                    label="Horas"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Por favor agrega las horas',
                                        },
                                    ]}>
                                    <InputNumber placeholder="Por favor agrega las horas" style={{ width: '80%', }} />
                                </Form.Item>
                            </Col>

                            <Col md={{ span: 8 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                                <Form.Item
                                    name="analitica_id"
                                    label="Analítica"
                                >
                                    <Select
                                        placeholder="Por favor selecciona una analítica"
                                        onChange={changeAnalitica}
                                        style={{ width: '80%', }}

                                    >
                                        {
                                            analiticas.map((item) => <Option key={item.value} value={item.value}>{item.text}</Option>)
                                        }
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col md={{ span: 8 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                                <Form.Item
                                    name="referencia"
                                    label="Referencia"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Por favor agrega una referencia',
                                        },
                                    ]}
                                >
                                    <Input placeholder="Por favor agrega una referencia" />
                                </Form.Item>
                            </Col>
                            <Col md={{ span: 12 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                                <Form.Item
                                    name="activo"
                                    label="Activo"
                                >
                                    <Switch checkedChildren={<CheckOutlined />} unCheckedChildren={<CloseOutlined />} />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                }
            </>
        </Drawer>
    );
};
export default App;